// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--sDARm";
export var inner = "Footer-module--inner--1_Ntg";
export var small = "Footer-module--small--nvPnA";
export var smallTitle = "Footer-module--small-title--1Wht5";